// `??` falls back only on null/undefined — an empty-string build arg
// would slip through, and an empty apiBaseUrl turns every fetch into a
// relative URL that lands on the static nginx (HTTP 405). Treat empty
// the same as missing so the dev fallback (or the runtime guard below)
// kicks in.
const orDefault = (v: string | undefined, fallback: string): string =>
  v && v.length > 0 ? v : fallback;

export const config = {
  apiBaseUrl: orDefault(import.meta.env.VITE_API_BASE_URL, "http://localhost:8000"),
  apiPrefix: orDefault(import.meta.env.VITE_API_PREFIX, "/api/v1"),
  appName: orDefault(import.meta.env.VITE_APP_NAME, "onPatrimonIA"),
  appEnv: orDefault(import.meta.env.VITE_APP_ENV, "development"),
  sentryDsn: import.meta.env.VITE_SENTRY_DSN ?? "",
} as const;
